module.exports = __webpack_public_path__ + "static/media/homo_sapiens.brain.f7155367.svg";